import { configureStore } from '@reduxjs/toolkit'
import uiReducer from './slices/uiSlice'
import appReducer from './slices/appSlice'

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    app: appReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
